<template>
<div class="chapter">
<div class="inner_page">
<div class="box-f">
<h2 class="h2" id="list"><a id="page_ix"></a>Illustrations</h2>
</div>
<p class="illu"><a class="nounder" href="#/xhtml/ch03#fig01"><em>Blues in the Night</em> publicity still</a></p>
<p class="illu"><a class="nounder" href="#/xhtml/ch03#fig02"><em>Blues in the Night</em> publicity still</a></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch04#fig03" title="Link target outside of Sample"><em>Jammin’ the Blues</em> publicity still</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch04#fig04" title="Link target outside of Sample"><em>Dead Reckoning</em> publicity still</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch04#fig05" title="Link target outside of Sample"><em>Cover Girl</em> publicity still</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch04#fig06" title="Link target outside of Sample"><em>To Have and Have Not</em> publicity still</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch04#fig07" title="Link target outside of Sample"><em>Phantom Lady</em> publicity still</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch04#fig08" title="Link target outside of Sample"><em>Christmas Holiday</em> publicity still</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch04#fig09" title="Link target outside of Sample"><em>Gilda</em> publicity still</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch04#fig10" title="Link target outside of Sample"><em>Gilda</em> publicity still</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch04#fig11" title="Link target outside of Sample"><em>Black Angel</em> publicity still</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch04#fig12" title="Link target outside of Sample"><em>The Man I Love</em> lobby card publicity</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch05#fig13" title="Link target outside of Sample"><em>The Red Shoes</em> publicity still</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch05#fig14" title="Link target outside of Sample"><em>The Red Shoes</em> publicity still</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch05#fig15" title="Link target outside of Sample"><em>Words and Music</em> publicity still</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch05#fig16" title="Link target outside of Sample"><em>Young Man with a Horn</em> lobby card publicity</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch05#fig17" title="Link target outside of Sample"><em>The Band Wagon</em> publicity still</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch05#fig18" title="Link target outside of Sample"><em>A Star Is Born</em> publicity still</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch05#fig19" title="Link target outside of Sample"><em>A Star Is Born</em> publicity still</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch06#fig20" title="Link target outside of Sample"><em>Young at Heart</em> publicity still</span></p>
<p class="illu"><span class="nounder" href="#/xhtml/ch06#fig21" title="Link target outside of Sample"><em>Love Me or Leave Me</em> publicity still</span></p>
<p class="noindent"><a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?dc3a2186